<template>
  <div v-if="price" class="bg-white">
    <h2>{{ price | currency }}</h2>
    <span class="text-xs block float-none text-sh-secondary-darken-25">{{
      $t('summary.tax')
    }}</span>
  </div>
</template>
<script>
import currency from '../filters/currency';

export default {
  name: 'ProductPrice',
  filters: {
    currency
  },
  props: {
    price: {
      type: Number,
      required: true,
      default: 0
    }
  }
};
</script>
